import { get } from "@ember/object"
import _ from "lodash"

export default function (actionStream) {
  actionStream.onValue(([patch, _actionName]) => {
    _.chain(get(this, "cardStackTemplateUpdater.subscriptions"))
      .toPairs()
      .filter(function (tuple, _index) {
        let [_cardStackId, cardStackToObserveId] = tuple
        return patch.document.id === cardStackToObserveId
      })
      .forEach((tuple, _index) => {
        let [cardStackId, cardStackTemplateId] = tuple
        this.phantomCardStacks.applyTemplateCardsToCardStackIfNeeded(
          cardStackId,
          cardStackTemplateId
        )
      })
      .value()
  })
}
